// extracted by mini-css-extract-plugin
export default {"header":"TeamDetail_header__13hy5","contentTop":"TeamDetail_contentTop__3du9f","title":"TeamDetail_title__2i0m_","actions":"TeamDetail_actions__3UM82"};